export class FillStyle {
  public color: string;
  // public pattern: number[];

  constructor(color: string) { // , pattern: number[]
    this.color = color;
    // this.pattern = new Array<number>(...pattern);
  }
}
